import { render, staticRenderFns } from "./advantages-section.vue?vue&type=template&id=86431c06&scoped=true&"
import script from "./advantages-section.vue?vue&type=script&lang=js&"
export * from "./advantages-section.vue?vue&type=script&lang=js&"
import style0 from "./advantages-section.vue?vue&type=style&index=0&id=86431c06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86431c06",
  null
  
)

export default component.exports